
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo-pages",
      function () {
        return require("private-next-pages/demo-pages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo-pages"])
      });
    }
  